"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyShellApi = void 0;
exports.propertyShellApi = (http, prefix = '/property/shell') => ({
    create(property) {
        return http.post(`${prefix}`, property);
    }
});
//# sourceMappingURL=index.js.map